import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useLogout } from 'shared/hooks'
import { getApplicationSystemInfo } from 'shared/utils'

const LoggedOut = () => {
  const { handleLoggedOut } = useLogout()

  const { logoutRedirectUrl } = getApplicationSystemInfo()

  const [searchParams] = useSearchParams()

  const redirectOriginFromLogoutaAction = searchParams.get('redirectOrigin')

  useEffect(() => {
    handleLoggedOut()
    const redirectOrigin = redirectOriginFromLogoutaAction || logoutRedirectUrl
    window.location.replace(redirectOrigin)
  }, [handleLoggedOut, logoutRedirectUrl, redirectOriginFromLogoutaAction])

  return null
}

export default LoggedOut
